import axios from 'axios';
import { devError, sanitizeForLog } from '../utils/logger';

// Configuration dynamique de l'URL de l'API
const getApiUrl = () => {
  return process.env.REACT_APP_BACKEND_URL || 'https://api.alturionlabs.com/api';
};

// Configuration de base
const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  timeout: 30000 // 30 secondes de timeout
});

// Log de l'URL utilisée
console.log('🔗 API URL:', getApiUrl());

// Intercepteur de requêtes
api.interceptors.request.use(
  (config) => {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      const { token } = JSON.parse(userInfo);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    devError('Erreur d\'interception de requête:', sanitizeForLog(error));
    return Promise.reject(error);
  }
);

// Intercepteur de réponses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    devError('Erreur de réponse:', sanitizeForLog(error));
    if (error.response?.status === 401) {
      localStorage.removeItem('userInfo');
      // Pour déboguer, on désactive la redirection vers '/login'
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 